'use client';

import React from 'react';
import { CheckCircle2, XCircle, Info, X } from 'lucide-react';
import { useApp } from '@/context/AppContext';

const ICONS = {
  success: <CheckCircle2 className="w-4 h-4 ic-green" />,
  error: <XCircle className="w-4 h-4 ic-red" />,
  info: <Info className="w-4 h-4 ic-blue" />,
};

const BORDER = {
  success: 'border-[#34d399]/30',
  error: 'border-[#f87171]/30',
  info: 'border-[#60a5fa]/30',
};

export default function ToastContainer() {
  const { toasts, dismissToast } = useApp();

  return (
    <div className="fixed bottom-24 lg:bottom-6 right-4 sm:right-6 z-[100] flex flex-col gap-2.5 w-[min(20rem,calc(100vw-2rem))]">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`glass-panel ${BORDER[t.type]} p-3.5 flex items-center gap-3 animate-slide-up`}
        >
          {ICONS[t.type]}
          <span className="text-xs font-medium text-white flex-1">{t.message}</span>
          <button
            onClick={() => dismissToast(t.id)}
            className="text-[#4a4a4a] hover:text-white transition"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
}
